import { Button } from 'primereact/button'

type Props = {
  icon: string
  label: string
  // backgroundColor: string
  textColor?: string
  onClick: any
}

const RateButton = ({
  icon,
  label,
  // backgroundColor,
  textColor = '#fff',
  onClick,
}: Props) => {
  return (
    <div className="col-6">
      <Button
        className="p-button-rounded discord p-0 w-full"
        aria-label={label}
        style={{
          background: '#fff',
          color: '#333',
          // color: textColor,
          border: `1px solid var(--surface-border)`,
        }}
        onClick={onClick}
      >
        <img width="30px" height="30px" src={icon} />
        <span className="px-2" style={{ textTransform: 'none' }}>
          {label}
        </span>
      </Button>
    </div>
  )
}

export default RateButton
